import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";
import Sort from "../../lib/appfuse-react/core/Sort";

const name = 'monthlyReportSettlement';

const initialState = {
    data: [],
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    defaultHospital: null
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        }
    }
});

export const { setData, setPageNumber, setPageSize, setCriteria, setSort } = slice.actions;

export const selectData = state => json.fromJSON(state[name].data);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort, Sort);

const monthlyReportSettlementReducer = slice.reducer;
export default monthlyReportSettlementReducer;